import { serverSidePagePrepare } from "@lib/hooks"
import { observer } from "mobx-react"
import {
  DocumentTemplate,
  Header,
  Page,
  PureLogo,
  useStore,
} from "@features/common"
import { RouterLink } from "@lib/routing"
import { scrollToTop } from "@lib/scroll"
import { IconHamburger } from "@lib/icons"
import {
  DesktopTableOfContents,
  LegalSectionView,
  TouchTableOfContents,
} from "@features/terms"
import { redirect } from "@lib/isomorphic"
import { PrivacyLogo } from "@features/privacy"

export const getServerSideProps = serverSidePagePrepare({
  callback: async ({ Models, ctx }) => {
    const { effective_date } = ctx.query
    const queryDate = Array.isArray(effective_date)
      ? effective_date[0]
      : effective_date

    try {
      const countryCode = await Models.GlobalModel.getClientCountryCode(ctx)
      await Models.LegalModel.getDataProcessingPageData(queryDate, countryCode)
    } catch {
      redirect(`/${Models.GlobalModel.lang}/not-found`, ctx)
    }
  },
})

const PersonalDataProcessingPage = observer(
  function PersonalDataProcessingPage() {
    const {
      GlobalModel: { openMenu },
      LegalModel: { dataProcessingSections, dataProcessingTitle },
    } = useStore()

    return (
      <Page
        meta={{
          title: dataProcessingTitle,
        }}
        header={
          <Header
            theme="dark"
            logo={
              <RouterLink
                uri="/legal/personal-data-processing"
                onClick={() => scrollToTop()}
                data-test-id="header__pure_logo"
                aria-label="root"
                className="mt-4 mb-3 tablet-m:mt-[20px] tablet-m:mb-[18px]"
              >
                <div className="shrink-0 flex items-stretch h-4 tablet-m:h-7">
                  <PureLogo className="shrink-0 block h-full w-auto tablet:h-full text-white pr-2 tablet-m:pr-4" />
                  <PrivacyLogo />
                </div>
              </RouterLink>
            }
            languageSwitcher={null}
            navigationOpener={
              <button
                onClick={openMenu}
                data-test-id="header__menu_button"
                aria-label="menu"
              >
                <IconHamburger className="w-8 h-8 text-white" />
              </button>
            }
          />
        }
        seoH1={dataProcessingTitle}
      >
        <div className="container pt-3 pb-15 laptop:pt-8 laptop:pb-20 legal-document">
          {dataProcessingSections.length > 1 ? (
            <TouchTableOfContents tableOfContents={dataProcessingSections} />
          ) : null}
          <DocumentTemplate
            sidebar={
              dataProcessingSections.length > 1 ? (
                <DesktopTableOfContents
                  tableOfContents={dataProcessingSections}
                />
              ) : null
            }
          >
            <section className="space-y-10" id="scrollContainerElement">
              {dataProcessingSections.map((i) => (
                <LegalSectionView data={i} key={i.id} id={i.id} />
              ))}
            </section>
          </DocumentTemplate>
        </div>
      </Page>
    )
  },
)

export default PersonalDataProcessingPage
